import React, { useEffect, useState } from "react";
import { Loading } from "../Other/Loading";
import {
  courseViewTypes,
  courseSortOptionsSubjects,
  courseSortOptionsSkillLevel,
  courseSortOptionsMostRelevant,
  courseSortOptionsLearningType,
  courseSortOptionsAvailability,
} from "../../_constants/staticData";
import CourseTile from "./CourseTile/CourseTile";
import { SearchBar } from "../Other/Search/Search";
const categoryMap = [
  "All Courses",
  "Finance",
  "Uncategorized",
  "Adult Content",
  "Languages",
  "Art & Design",
  "Broadcasting",
  "Politics",
  "Sports",
  "Food & Nutrition",
  "Style & Beauty",
  "Home & Gardening",
  "Engineering",
  "Post Secondary",
  "Academics & Education",
  "Music & Dance",
  "Health & Fitness",
  "Video & Photography",
  "LifeStyle",
  "Sales & Marketing",
  "IT & Software",
  "Development",
  "Business",
];

const price = ["$1 - $25", "$26 - $50", "$51 - $75", "$76 - $100"];

export const Courses = ({
  courses,
  title,
  varient,
  setSelectedCourses,
  total,
  isFetching,
  handlefilterChange,
  Filter,
  setFilter,
  bundle,
}) => {
  const [viewType, setViewType] = useState("tile");

  // Sort by created date
  const sortByCreatedDate = (a, b) =>
    new Date(b.CreatedOn) - new Date(a.CreatedOn);

  // Sort by highest rated
  const sortByHighestRated = (a, b) => b.StarRating - a.StarRating;

  // Sort course handle
  const handleSortCourses = (sortBy) => {
    const courseData = [...courses];
    switch (sortBy) {
      case "rated":
        setSelectedCourses(courseData.sort(sortByHighestRated));
        break;
      case "latest":
        setSelectedCourses(courseData.sort(sortByCreatedDate));
        break;
      default:
        setSelectedCourses(courseData);
    }
  };

  const handleCourseView = (sortType) => {
    setViewType(sortType);
  };

  return (
    <div className="courseList">
      <div>
        <div className="content margin-top-new-40">
          <div className="bg-color-courselist">
            <div className="inner-wrapper">
              {/* <div className="course-page-title">
                {title}
                <span className="total-courses-courselist">
                  {bundle
                    ? `${
                        courses?.bundleCourses?.length === 0
                          ? "..."
                          : courses?.bundleCourses?.length
                      } Bundles in Edusity`
                    : `${
                        total === undefined ? "..." : total
                      } courses in Edusity`}
                </span>
              </div> */}

              <div className="top-wrapper">
                {/* <div
                  className={`search-wrapper ${
                    varient === "courses" ? "courses" : ""
                  }`}
                >
                  <SearchBar Filter={Filter} setFilter={setFilter} />
                </div> */}

                {/* <div className="sort-wrapper">
                  {courseViewTypes?.map((sort) => {
                    return (
                      <i
                        key={sort.key}
                        className={`${sort.icon} ${
                          sort.type === viewType ? "active" : ""
                        }`}
                        onClick={() => handleCourseView(sort.type)}
                      ></i>
                    );
                  })}
                </div> */}
              </div>
            </div>
          </div>
          {!bundle && (
            <div className="bg-course-bg-color">
              <div className="inner-wrapper">
                {/* <div className="course-page-title">
                  {bundle ? "Sort Bundles" : "Sort Courses"}
                </div> */}

                <div>
                  <div className="sort-wrapper">
                    {/* <div className="sort-dropdown">
                      <select
                        aria-label="sortDropdown"
                        name="fliterCategory"
                        onChange={handlefilterChange}
                        value={Filter?.fliterCategory}
                      >
                        <option value="" hidden>
                          All Courses
                        </option>
                        {categoryMap?.sort()?.map((sort, index) => (
                          <option key={index} value={sort}>
                            {sort}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsSubjects.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        // onChange={(e) =>
                        //   handleSortCourses(e.target.value, courses)
                        // }

                        disabled={true}
                      >
                        <option value="" hidden>
                          Price Range
                        </option>
                        {price.map((sort, index) => (
                          <option key={index} value={sort}>
                            {sort}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="sort-dropdown ">
                      <select
                        aria-label="sortDropdown"
                        onChange={handlefilterChange}
                        name="fliterLevel"
                        value={Filter?.fliterLevel}
                      >
                        <option hidden>Skill Level</option>
                        {courseSortOptionsSkillLevel.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsMostRelevant.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsLearningType.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    {/* <div className="sort-dropdown disabledSelectDropdown">
                      <select
                        aria-label="sortDropdown"
                        onChange={(e) =>
                          handleSortCourses(e.target.value, courses)
                        }
                        disabled={true}
                      >
                        {courseSortOptionsAvailability.map((sort) => (
                          <option key={sort.key} value={sort.value}>
                            {sort.label}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="inner-wrapper">
            <div
              className={`content-inner-wrapper ${
                viewType === "list" ? "list-view" : ""
              }`}
            >
              <div className="sort-column">
                {/* <div className="sort-inner-wrapper">
                  <div className="sort-title">Categories</div>
                </div> */}
              </div>
              {bundle ? (
                <>
                  {courses.loading ? (
                    <div className="content margin-top-new-40 text-center-courses">
                      <Loading />
                    </div>
                  ) : (
                    <div className="tile-column">
                      {courses?.bundleCourses?.map((post, key) => (
                        <CourseTile
                          post={post}
                          key={key}
                          bundle={bundle}
                          viewType={viewType}
                        />
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="tile-column">
                  {courses?.length > 0
                    ? courses?.map((post, key) => {
                        return (
                          <CourseTile
                            post={post}
                            key={key}
                            viewType={viewType}
                          />
                        );
                      })
                    : courses
                        ?.filter((ele) => ele.Status === 3)
                        ?.map((post, key) => (
                          <CourseTile post={post} key={key} />
                        ))}
                  <div className="content margin-top-new-40 text-center-courses">
                    {courses?.length === 0 && isFetching && (
                      <div className="available-course-loading">
                        <Loading />
                      </div>
                    )}
                    {total === 0 && !isFetching && (
                      <div className="no-available-courses-record">
                        <span className="recordNotFound">No Record found</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
